exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-select-dropdown__item.selected {\n    color: #18333d;\n}\n@media screen and (max-width: 600px) {\n.el-message-box__wrapper {\n\t\tleft: 10px;\n\t\tright: 10px;\n}\n.el-message-box {\n\t\twidth: auto;\n}\n}\n", ""]);

// exports
